import { DASHBOARD_TOUR_STEPS } from "./steps/dashboard.steps";
import { resolveTourStepsForRole } from "./resolveTourStepsForRole";

export function resolveDashboardSteps(role, options = {}) {
  return resolveTourStepsForRole(DASHBOARD_TOUR_STEPS, role, options);
}
